import styled from 'styled-components';
import IconPointerDownOutline from './IconPointerDownOutline';
var IconPointerUpOutline = /*#__PURE__*/styled(IconPointerDownOutline).withConfig({
  displayName: "IconPointerUpOutline",
  componentId: "c11n-8-107-0__sc-kkost4-0"
})(["transform:rotate(180deg);"]);
export default IconPointerUpOutline;